import axios from 'axios';
import { ENV } from '../../config/env';
import { ApiResponse } from '../../types/api';
import { get } from '../httpMethods';

export type MediaFolder = 'employee' | 'doctor' | 'patient' | 'general';

export interface StorageHealth {
  ok: boolean;
  provider: string;
  bucket: string;
  publicUrl: string;
  error?: string;
}

/**
 * Uploads an image to the shared media endpoint and returns its public URL.
 * Uses a fresh axios instance so the browser sets the multipart boundary.
 *
 * Forms must upload images here and persist only the returned URL — never a
 * base64 data URL, which exceeds the JSON body limit and the varchar(255)
 * columns used to store these URLs.
 */
export const mediaService = {
  uploadImage: async (
    file: File,
    folder: MediaFolder = 'general',
  ): Promise<ApiResponse<{ url: string }>> => {
    const formData = new FormData();
    formData.append('file', file);
    const API_BASE_URL = `${ENV.VITE_API_URL}${ENV.VITE_API_BASE_PATH || '/api/v1'}`;
    const response = await axios.post<ApiResponse<{ url: string }>>(
      `${API_BASE_URL}/media/upload?folder=${folder}`,
      formData,
      { withCredentials: true, timeout: 60000 },
    );
    return response.data;
  },

  checkHealth: (): Promise<ApiResponse<StorageHealth>> => {
    return get<StorageHealth>('/media/health');
  },
};
